import {
    Button,
    Col,
    InputNumber,
    Modal,
    notification,
    Row,
    Slider,
} from 'antd'
import ButtonGroup from 'antd/lib/button/button-group'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
    addPatientMeasurementRecordApi,
    listOfPatientMeasurementRecordApi,
} from '../../../../config/Api'
import {
    API_ERR_MESSAGE,
    MEASUREMENT_TYPE_IMAGE_BASE_URL,
} from '../../../../config/constant'
import {
    cmToFeetInch,
    decimalFeetToFeetInch,
    formatFeetInch,
} from '../../../../services/Height'

import '../style/Measurements.scss'
import { MeasurementDataModal } from './MeasurementDataMaster/MeasurementDataModal'

// export const Measurements = ({ image, Title, Types }) => {
export const Measurements = (props) => {
    const { id } = useParams()

    // console.log("immg",props.MeasurementData.image);
    const [loading, setLoading] = useState(false)
    const [inputValue, setInputValue] = useState()
    const [minValue, setMinValue] = useState()
    const [maxValue, setMaxValue] = useState()
    const [measurementType, setMeasurementType] = useState()
    const [filteredData, setFilteredData] = useState()
    const [selectedUnitId, setSelectedUnitId] = useState()
    const [measurementRecordedData, setMeasurementRecordedData] = useState()
    const [title, setTitle] = useState('')
    // const [flag, setFlag] = useState(false);

    const [isModalVisible, setIsModalVisible] = useState(false)

    // get the list of all measurement recorded values of patient
    //==============================
    const getListOfMeasurementTypesRecords = () => {
        setLoading(true)

        listOfPatientMeasurementRecordApi({ patient_id: parseInt(id) })
            .then((res) => {
                if (res.status === 200) {
                    setMeasurementRecordedData(res.data.data)

                    // Find latest record for this specific measurement type
                    const recordsForThisType = res.data.data.filter(
                        (r) =>
                            r.measurement_type_id === props.MeasurementData.id
                    )

                    if (recordsForThisType.length > 0) {
                        // The records are usually returned sorted by date desc from backend
                        const latestRecord = recordsForThisType[0]
                        setInputValue(parseFloat(latestRecord.value))

                        // Match the unit from the record to our available units to set min/max
                        const matchingUnit =
                            props.MeasurementData.measurements_type_unit.find(
                                (u) =>
                                    u.unit.name ===
                                    latestRecord.measurement_unit
                            )
                        if (matchingUnit) {
                            setMeasurementType(matchingUnit.unit.name)
                            setMinValue(parseFloat(matchingUnit.min_value))
                            setMaxValue(parseFloat(matchingUnit.max_value))
                        }
                    }
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }
    useEffect(() => {
        getListOfMeasurementTypesRecords()
    }, [])

    // to set the min max value of slider
    //==============================
    const measurements = (unit) => {
        // Find 'cm' unit first if it's Height, else use first one
        let selected = unit.measurements_type_unit[0]
        const cmUnit = unit.measurements_type_unit.find(
            (u) => u.unit.name.toLowerCase() === 'cm'
        )
        if (cmUnit) selected = cmUnit

        if (selected) {
            setMeasurementType(selected.unit.name)
            setMinValue(parseFloat(selected.min_value))
            setMaxValue(parseFloat(selected.max_value))
        }
    }
    useEffect(() => {
        // Set default initial value based on default unit's min
        const cmUnit = props.MeasurementData.measurements_type_unit.find(
            (u) => u.unit.name.toLowerCase() === 'cm'
        )
        const defaultUnit =
            cmUnit || props.MeasurementData.measurements_type_unit[0]

        if (defaultUnit) {
            setInputValue(parseFloat(defaultUnit.min_value))
        }
        measurements(props.MeasurementData)
    }, [])

    const onChange = (newValue) => {
        setInputValue(newValue)
    }

    // when user change selected unit set the min and max value of that record as per unit
    //==============================
    const handleUnit = (record) => {
        if (inputValue && record) {
            let convertedValue = inputValue

            // Use formula from DB if available, otherwise fallback to standard constants for cm/in
            let formula = parseFloat(record.formula)

            if (isNaN(formula) || formula === null) {
                // Fallback for common units if DB formula is missing (like Waist)
                if (
                    record.unit.name.toLowerCase() === 'cm' &&
                    measurementType === 'in'
                ) {
                    formula = 2.54
                } else if (
                    record.unit.name.toLowerCase() === 'in' &&
                    measurementType === 'cm'
                ) {
                    formula = 0.3937
                }
            }

            if (formula && !isNaN(formula)) {
                convertedValue = inputValue * formula
            }

            // Snap to nearest integer if extremely close to prevent drift
            if (Math.abs(convertedValue - Math.round(convertedValue)) < 0.01) {
                convertedValue = Math.round(convertedValue)
            }

            // Round appropriately: 2 decimals if the type allows it, else whole number
            setInputValue(
                props.MeasurementData.isDecimal
                    ? parseFloat(convertedValue.toFixed(2))
                    : Math.round(convertedValue)
            )
        }

        setSelectedUnitId(record?.unit_id)
        setMeasurementType(record.unit.name)
        setMinValue(parseFloat(record.min_value))
        setMaxValue(parseFloat(record.max_value))
    }

    const onSubmit = (measurementRecordData) => {
        const apiData = {
            value: inputValue,
            patient_id: parseInt(id),
            measurement_type_id: measurementRecordData?.id,
            measurement_unit: measurementType,
        }

        addPatientMeasurementRecordApi(apiData)
            .then((res) => {
                if (res.status === 200) {
                    notification.success({
                        message: 'Measurement Record added successfully',
                    })
                    getListOfMeasurementTypesRecords()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    } // onSubmit over

    const handleCancel = () => {
        setIsModalVisible(false)
    }

    return (
        <>
            <Row>
                <Col xs={24} sm={24} md={20} lg={20} xl={21} xxl={22}>
                    {/* <Spin spinning={loading} className="spinner-code"> */}
                    <Row className="Measurements">
                        <Col
                            xs={24}
                            sm={24}
                            md={20}
                            lg={20}
                            xl={22}
                            xxl={22}
                            className="pt-2 pb-2"
                        >
                            <img
                                src={
                                    MEASUREMENT_TYPE_IMAGE_BASE_URL +
                                    props.MeasurementData.image
                                }
                                alt="Weight"
                                width={50}
                            />
                            <span className="title">
                                {props.MeasurementData.name}
                            </span>
                            <InputNumber
                                controls={false}
                                min={minValue}
                                max={maxValue}
                                style={{ margin: '0 16px' }}
                                value={inputValue || 0}
                                step={
                                    props.MeasurementData.isDecimal
                                        ? 0.01
                                        : null
                                }
                                onChange={onChange}
                            />
                            <span>{measurementType}</span>
                            {props.MeasurementData.name === 'Height' &&
                                measurementType === 'ft' && (
                                    <span className="ms-2 text-secondary">
                                        ({formatFeetInch(decimalFeetToFeetInch(inputValue))})
                                    </span>
                                )}
                            {props.MeasurementData.name === 'Height' &&
                                measurementType === 'cm' && (
                                    <span className="ms-2 text-secondary">
                                        ({formatFeetInch(cmToFeetInch(inputValue))})
                                    </span>
                                )}
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4} xl={2} xxl={2}>
                            <ButtonGroup className="align-self-center float-end">
                                {
                                    // props.MeasurementData.Type.map((element, index) => (
                                    props?.MeasurementData
                                        ?.measurements_type_unit?.length > 0 &&
                                        props.MeasurementData.measurements_type_unit.map(
                                            (element, index) => (
                                                <Button
                                                    key={index}
                                                    onClick={() =>
                                                        handleUnit(element)
                                                    }
                                                    className="align-self-center border-0"
                                                    style={{
                                                        background:
                                                            measurementType ==
                                                            element.unit.name
                                                                ? '#5F4B8BFF'
                                                                : '',
                                                        color:
                                                            measurementType ==
                                                            element.unit.name
                                                                ? '#FFFFFF'
                                                                : '',
                                                    }}
                                                    value={element.unit.name}
                                                >
                                                    {element.unit.name}
                                                </Button>
                                            )
                                        )
                                }
                            </ButtonGroup>
                        </Col>
                        <hr className="w-100 m-0" />
                        <Col
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={2}
                            xxl={2}
                            className="text-center"
                        >
                            <span>
                                {minValue} {measurementType}
                            </span>
                        </Col>
                        <Col xs={16} sm={16} md={16} lg={16} xl={20} xxl={20}>
                            <Slider
                                min={minValue}
                                max={maxValue}
                                onChange={onChange}
                                value={
                                    typeof inputValue === 'number'
                                        ? inputValue
                                        : 0
                                }
                                step={props.MeasurementData.isDecimal && 0.01}
                                className="mx-4 align-self-center"
                            />
                        </Col>
                        <Col
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={2}
                            xxl={2}
                            className="text-center"
                        >
                            <span>
                                {maxValue} {measurementType}
                            </span>
                        </Col>
                    </Row>
                    {/* </Spin> */}
                </Col>

                <Col
                    xs={24}
                    sm={24}
                    md={4}
                    lg={4}
                    xl={3}
                    xxl={2}
                    className="action-buttons"
                >
                    <Button
                        block
                        onClick={() => onSubmit(props.MeasurementData)}
                        htmlType="submit"
                    >
                        Save
                    </Button>
                    {/* <Button block onClick={(e) => handleUnit(e.target.value)} value="in">View Record</Button> */}
                    <Button
                        block
                        onClick={() => setIsModalVisible(true)}
                        value="in"
                    >
                        View Record
                    </Button>
                </Col>
            </Row>
            <Modal
                open={isModalVisible}
                // centered
                footer={null}
                width={800}
                className="addPlanPricing rounded"
                onCancel={handleCancel}
            >
                <MeasurementDataModal
                    measurementData={props.MeasurementData}
                    measurementRecordedData={measurementRecordedData}
                    // Types={props.MeasurementData.Type}
                    handleUnit={handleUnit}
                    setFilteredData={setFilteredData}
                    filteredData={filteredData}
                    measurementType={measurementType}
                    // flag={flag}
                    // setFlag={setFlag}
                />
            </Modal>
        </>
    )
}
